<template>
    <main-dialog
        :title="$t('convertTxtToPdf')"
        v-model="isVisible"
        @ok="handleConvert"
        :ok-title="$t('convert')"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
    >
        <div class="txt-convert-form">
            <b-form-group :label="$t('inputFile')" label-for="input-file">
                <b-form-input
                    id="input-file"
                    :value="file.name"
                    disabled
                    readonly
                />
            </b-form-group>

            <b-form-group :label="$t('outputFileName')" label-for="output-filename">
                <b-form-input
                    id="output-filename"
                    v-model="outputFileName"
                    :placeholder="$t('enterOutputFileName')"
                />
            </b-form-group>

            <b-form-group>
                <b-form-checkbox v-model="downloadAsPdf">
                    {{ $t('downloadAsPdf') }}
                </b-form-checkbox>
                <small class="form-text text-muted">{{ $t('downloadAsPdfHint') }}</small>
            </b-form-group>

            <b-form-group v-if="!downloadAsPdf">
                <b-form-checkbox v-model="saveToLibrary">
                    {{ $t('saveToLibrary') }}
                </b-form-checkbox>
                <small class="form-text text-muted">{{ $t('saveToLibraryHint') }}</small>
            </b-form-group>

            <b-form-group
                v-if="!downloadAsPdf && saveToLibrary"
                :label="$t('outputPath')"
                label-for="output-path"
            >
                <b-form-input
                    id="output-path"
                    v-model="outputPath"
                    :placeholder="$t('enterOutputPath')"
                />
                <small class="form-text text-muted">{{ $t('outputPathHint') }}</small>
            </b-form-group>
        </div>
    </main-dialog>
</template>

<script>
export default {
    name: 'TxtToPdfModal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        file: {
            type: Object,
            required: true
        },
        currentPath: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            outputFileName: '',
            downloadAsPdf: false,
            saveToLibrary: true,
            outputPath: ''
        };
    },
    computed: {
        isVisible: {
            get() {
                return this.show;
            },
            set(value) {
                if (!value) {
                    this.$emit('close');
                }
            }
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.initializeForm();
            }
        }
    },
    methods: {
        initializeForm() {
            const baseName = this.file.name.replace(/\.txt$/i, '');
            this.outputFileName = `${baseName}.pdf`;
            this.outputPath = this.currentPath;
            this.downloadAsPdf = false;
            this.saveToLibrary = true;
        },
        handleConvert(bvModalEvt) {
            bvModalEvt.preventDefault();

            if (!this.outputFileName) {
                this.$bvToast.toast(this.$t('pleaseEnterOutputFileName'), {
                    title: this.$t('error'),
                    variant: 'danger'
                });
                return;
            }

            const options = {
                output_file_name: this.outputFileName,
                output_pdf: this.downloadAsPdf
            };

            if (!this.downloadAsPdf && this.saveToLibrary) {
                options.output_path = this.outputPath;
            }

            this.$emit('convert', options);
            this.isVisible = false;
        }
    }
}
</script>

<style scoped>
.txt-convert-form {
    padding: 10px 0;
}
</style>
